// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mosh","right":"styles_right__1yyRm"};